<section class="text-center">
  <div class="row justify-content-center">
    <div class="col-xm-12 col-sm-10 col-md-8 col-lg-3 col-xl-3 customChart">
      <app-radar-chart></app-radar-chart>
    </div>
    <div class="col-xm-12 col-sm-10 col-md-10 col-lg-5 col-xl-5 customCamera">
      <div class="speechText container mt-3">
            <span style="position: absolute; right: -10px;top: 20px; margin: 10px" [hidden]="!showDownloadLink">
            <a id="downloadLink">
            <img src="assets/speech/download.webp" height="48" width="48" alt="Download">
            </a>
            </span>
        <span style="position: absolute; left: 20px;top: 10px; margin: 10px" [hidden]="!showDownloadLink">
            <button *ngIf="!playingWave" (click)="playWave()" class="recorderButton">
            <img src="assets/speech/play.svg" alt="Play" height="36" width="36">
            </button>
            <button *ngIf="playingWave" (click)="stopWave()" class="recorderButton">
            <img src="assets/speech/stop.svg" alt="Stop" height="36" width="36">
            </button>
            </span>
        <span style="position: absolute; right: 10px;top: 173px; margin: 10px" [hidden]="!shoeServiceReplyMsg">
               <div class="animate-flicker" style="font-size: small; color: green">Service reply...</div>
            </span>
        <span class="float-center">
<!--            <button *ngIf="!audioIsActive" (click)="startAudio()" class="recorderButton">-->
            <!--            <img class="recorderImg" src="assets/speech/start.webp" alt="Start">-->
            <!--            </button>-->
            <button *ngIf="!audioIsActive" class="recorderButton">
            <img class="recorderImg" src="assets/speech/start.webp" alt="Start">
            </button>
            <br/>
            <span style="color: red">It has been deactivated.</span>
            <button *ngIf="audioIsActive" (click)="stopAudio()" class="recorderButton">
            <img class="recorderImg" src="assets/speech/stop.webp" alt="Stop">
            </button>
            </span>
        <div
          style="margin-top: 10px; height: 120px;background-color: #002237; border: 3px solid #820024; border-radius: 10px">
          <div id="waveform"></div>
        </div>
        <hr/>
        <div class="text-center justify-content-around">
          <div id="emotionIcon" style="position: relative">
                  <span style="font-size: 6vw">
                  {{speechService.emotionMaxIcon}}
                  </span>
            <span *ngIf="speechService.emotionMaxText"
                  style="position: absolute;font-size: 2vw;font-weight: bold;bottom: 3vw;margin-left: 1vw">
                  {{speechService.emotionMaxText}}
                  </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xm-12 col-sm-10 col-md-8 col-lg-3 col-xl-3 customChart">
         <pre style="font-size: 1vw;font-weight: bold;"><span
           style="color:#FAAF13">{{speechService.emotionalLocalMsgAngry}}</span>
<span style="color:#583342">{{speechService.emotionalLocalMsgDisgust}}</span>
<span style="color:#7C8B30">{{speechService.emotionalLocalMsgFear}}</span>
<span style="color:#A72229">{{speechService.emotionalLocalMsgHappy}}</span>
<span style="color:#292148">{{speechService.emotionalLocalMsgNeutral}}</span>
<span style="color:#504F4F">{{speechService.emotionalLocalMsgSad}}</span>
<span style="color:#0475C0">{{speechService.emotionalLocalMsgSurprise}}</span>
<span style="color:#D74407">{{speechService.emotionalLocalMsgContemptuous}}</span></pre>
      <hr/>
      <span *ngIf="audioIsActive">
         <img style="border-radius: 50%" src="assets/speech/listening.gif" height="96" width="96"
              alt="Listening">
        &nbsp;&nbsp;
        <i class="fa fa-circle {{speak?'speakColor':'notSpeakColor'}}"></i>
        &nbsp;&nbsp;
         <img *ngIf="!speak" src="assets/speech/stopSpeak.jpg" height="96" width="128"/>
        <img *ngIf="speak" src="assets/speech/speak.gif" height="96" width="128"/>

         </span>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-xm-12 col-sm-12 col-md-3 col-lg-5 col-xl-5">
      <div id="divPreview" class="customChart">
        <h3>Spectrogram</h3>
        <canvas id="canvasSpectro"></canvas>
      </div>
    </div>
    <div class="col-xm-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 customChart2">
      <app-chart #chartComponent></app-chart>
    </div>
  </div>
</section>
